"use client";

import {
  PortableTextProps,
  PortableTextReactComponents,
  PortableText as SanityPortableText,
} from "next-sanity";
import { CLink } from "./customLink/CustomLink";
import { linkType } from "@/apiUtils/constants";
import root from "react-shadow";
import { PTConverter } from "@/apiUtils/commonUtils";

const components: Partial<PortableTextReactComponents> = {
  marks: {
    link: ({ children, value }) => {
      return (
        <CLink
          className="underline"
          href={value?.url}
          target={value?.type === linkType.EXTERNAL ? "_blank" : ""}
        >
          {children}
        </CLink>
      );
    },
  },
  block: {
    normal: ({ children }) => {
      if (children && Array.isArray(children) && children[0] === "") {
        return <br />;
      }
      return <p className="">{children}</p>;
    },
  },
};
const PortableText = ({ value }: PortableTextProps) => {
  return (
    <root.span>
      <style>
        {`
            p {
                margin: 0;
                padding: 0;
              }
            a {
                color: #666666;
              }
          `}
      </style>
      <SanityPortableText value={PTConverter(value)} components={components} />
    </root.span>
  );
};
export default PortableText;
